"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingUpdateData = void 0;
const utils_1 = require("../../utils");
const lodash_1 = __importDefault(require("lodash"));
var RatingUpdateData;
(function (RatingUpdateData) {
    function updateFields(data) {
        const updateFields = {};
        if (!lodash_1.default.isUndefined(data.value))
            updateFields['value'] = data.value;
        const cleaned = (0, utils_1.omitDeepUndefined)(updateFields);
        if (!lodash_1.default.isEmpty(cleaned)) {
            cleaned['modifiedAt'] = Date.now();
        }
        return cleaned;
    }
    RatingUpdateData.updateFields = updateFields;
})(RatingUpdateData || (exports.RatingUpdateData = RatingUpdateData = {}));
//# sourceMappingURL=RatingUpdateData.js.map